export const COOKIE_KEY_SKIP_REDIRECT = 'fallback.skip-redirect';
